@if (validationError()) {
<div class="min-h-[24px] mt-2">
  <p
    class="flex items-center text-sm font-medium text-red-600 animate-in fade-in slide-in-from-top-1"
  >
    <svg class="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
      <path
        fill-rule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
        clip-rule="evenodd"
      />
    </svg>
    {{ validationError() }}
  </p>
</div>
} @if (validationWarning()) {
<div class="min-h-[24px] mt-2">
  <p
    class="flex items-center text-sm font-medium text-amber-600 animate-in fade-in slide-in-from-top-1"
  >
    <svg class="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
      <path
        fill-rule="evenodd"
        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
        clip-rule="evenodd"
      />
    </svg>
    {{ validationWarning() }}
  </p>
</div>
}
